/* tslint:disable:cyclomatic-complexity */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from "react";
import { Animate } from "sb-resp-ui";
import { returnColor, processColorDiff, splitTime, parseTime } from "sb-helpers";
var defaultStartingWidth = 46; // related to the CSS, please be carefull
/* istanbul ignore next */
function trackProgress(duration, callback, animation, elements, complete, remaining, start, tweenValue) {
    this.iterator = this.totalTime - (this.totalProgress + (duration * complete));
    var d = 1 - Math.ceil((this.iterator / this.totalTime) * 100) / 100;
    var tmp = processColorDiff(this.colors, d);
    var time = parseTime(this.iterator);
    this.point && (this.point.innerText = time,
        this.point.style.background = "" + returnColor(tmp));
    this.trackBg && (this.trackBg.style.background = "linear-gradient(to right, " + returnColor(this.colors.start) + ", " + returnColor(tmp) + ")");
    if (typeof callback === "function") {
        callback(animation.value, d, time);
    }
}
/* istanbul ignore next */
function animation(segments, t, v1, v2) {
    var t1, animations;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                t1 = t;
                animations = segments.periods.map(function (x, i, a) {
                    var d = 0;
                    if (v2[i] === 0) {
                        t1 -= x.duration;
                    }
                    if (v1 > v2[i] && v2[i] > 0) {
                        d = x.duration - t1;
                    }
                    if (v1 === v2[i]) {
                        d = x.duration;
                    }
                    return __assign({}, x, { duration: d, startTime: x.startTime });
                });
                return [4 /*yield*/, __assign({}, animations[0], { width: "33.4%" })];
            case 1:
                _a.sent();
                return [4 /*yield*/, __assign({}, animations[1], { width: "66.7%" })];
            case 2:
                _a.sent();
                return [4 /*yield*/, __assign({}, animations[2], { width: "100%" })];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
var Track = /** @class */ (function (_super) {
    __extends(Track, _super);
    /* istanbul ignore next */
    function Track(props) {
        var _this = _super.call(this, props) || this;
        _this.colors = _this.props.colors;
        _this.endTime = splitTime(_this.props.segments.endTime);
        _this.startTime = splitTime(_this.props.segments.startTime);
        // this.totalTime = ((this.endTime[0] * 60 + this.endTime[1]) * 1000) - ((this.startTime[0] * 60 + this.startTime[1]) * 1000)
        _this.totalTime = _this.props.segments.periods.reduce(function (a, b) { return a += b.duration; }, 0) * 1000;
        _this.totalProgress = _this.props.segments.expiredBetProgressInMilliseconds;
        _this.iterator = _this.totalTime - _this.totalProgress;
        _this.state = {
            anim: {},
            startingWidth: defaultStartingWidth + "px",
            start: typeof _this.props.start === "undefined" ? true : _this.props.start
        };
        return _this;
    }
    /* istanbul ignore next */
    Track.prototype.shouldAnimate = function () {
        if (this.state.start && this.getAnimation) {
            this.startAnimation(this.getAnimation.next());
        }
    };
    /* istanbul ignore next */
    Track.prototype.componentDidMount = function () {
        var _this = this;
        var v = this.track && this.track.offsetWidth;
        if (v) {
            var v1_1 = v / 3;
            var t = this.props.segments.expiredBetProgressInMilliseconds / 1000;
            var t1_1 = t;
            var v2 = this.props.segments.periods.map(function (x) {
                var o = v1_1;
                if (t1_1 > 0) {
                    o = t1_1 >= x.duration ? 0 : (v1_1 / x.duration) * (x.duration - t1_1);
                }
                t1_1 -= x.duration;
                return o;
            });
            this.getAnimation = animation(this.props.segments, t, v1_1, v2);
            v2.filter(function (x) { return x === 0; }).forEach(function () { return _this.getAnimation.next(); });
            var d = v - v2.reduce(function (x, y) { return x += y; }, 0);
            // The progress calculations are described here
            // https://confluence.sbtech.com/display/FRON/My+pulse+bet+progress+calculation
            var startingWidth = d < v1_1 ? (1 - defaultStartingWidth / v1_1) * d + defaultStartingWidth : d;
            this.setState({ startingWidth: startingWidth / v * 100 + "%" });
        }
        this.shouldAnimate();
    };
    /* istanbul ignore next */
    Track.prototype.callCallback = function (cb, params) { typeof cb === "function" && cb.apply(void 0, __spread(params)); };
    /* istanbul ignore next */
    Track.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.start !== prevState.start) {
            return {
                start: nextProps.start
            };
        }
        /* tslint:disable:no-null-keyword */
        return null;
        /* tslint:enable:no-null-keyword */
    };
    /* istanbul ignore next */
    Track.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (prevState.start !== this.state.start) {
            this.shouldAnimate();
        }
    };
    /* istanbul ignore next */
    Track.prototype.startAnimation = function (animation) {
        var _this = this;
        if (!animation.done) {
            var duration_1 = animation.value.duration * 1000;
            this.setState({
                anim: {
                    animation: { width: animation.value.width },
                    easing: "linear",
                    duration: duration_1,
                    begin: function () {
                        if (_this.props.callbacks && _this.props.callbacks.begin) {
                            _this.callCallback(_this.props.callbacks.begin, [animation.value]);
                        }
                    },
                    progress: function (elements, complete, remaining, start, tweenValue) {
                        var cb;
                        if (_this.props.callbacks && _this.props.callbacks.progress) {
                            cb = _this.props.callbacks.progress;
                        }
                        trackProgress.call(_this, duration_1, cb, animation, elements, complete, remaining, start, tweenValue);
                    },
                    complete: function () {
                        _this.totalProgress += duration_1;
                        _this.startAnimation(_this.getAnimation.next());
                        if (_this.props.callbacks && _this.props.callbacks.complete) {
                            _this.callCallback(_this.props.callbacks.complete, [animation.value]);
                        }
                    }
                },
            });
        }
    };
    /* istanbul ignore next */
    Track.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "rj-pulse-bet__track", ref: function (n) { return _this.track = n; } },
            React.createElement(Animate, __assign({}, this.state.anim, { runOnMount: true, loop: false, reverse: false }),
                React.createElement("div", { className: "rj-pulse-bet__track-wrap", style: { width: "" + this.state.startingWidth } },
                    React.createElement("div", { className: "rj-pulse-bet__track-bg", ref: function (n) { return _this.trackBg = n; } }),
                    React.createElement("div", { className: "rj-pulse-bet__track-point", ref: function (n) { return _this.point = n; } }, parseTime(this.iterator))))));
    };
    return Track;
}(React.Component));
export { Track };
//# sourceMappingURL=Track.js.map